import { MasterInstallationApiModel } from '@core/api/model/master/master-installation-api.model';
import { MasterInstallationModel } from '@core/domain/model/master/master-installation.model';
import { UserDetailMapper } from '@core/domain/mappers/user/user-detail.mapper';

export class MasterInstallationMapper {
  public static modelFromApi(api: Array<MasterInstallationApiModel>): MasterInstallationModel[] {
    return api.map((installation) => ({
      ...installation,
      inactive: installation.baja,
      role: UserDetailMapper.roleMapper(installation.role),
      postalCode: installation.codigoPostal,
      tariff: installation.tarifa,
      clientType: installation.isPyme ? 'PYMES' : 'GGCC',
      contractStatus: installation.estadoContrato,
    }));
  }
}
